module.exports = __webpack_public_path__ + "static/media/05.6e616876.png";